import { render } from "./MyProperty.vue?vue&type=template&id=35a02ea4"
import script from "./MyProperty.vue?vue&type=script&lang=js"
export * from "./MyProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__